module.exports = __webpack_public_path__ + "static/media/play-circle.8516c0c8.svg";